import {Pipe, PipeTransform} from '@angular/core';
import {TimecardStatus} from '../../model';
import {NameFormatPipe} from '../shared/name-format.pipe';
import {AppStateService} from "../shared/app-state.service";

export interface TimecardFilterSortOptions {
  query: string | null;
  filter: string;
  sort: string;
  view: 'unsigned' | 'signed' | 'disputed';
}

@Pipe({name: 'timecardsFilterSort'})
export class TimecardFilterSortPipe implements PipeTransform {

  constructor(private AppState: AppStateService) {
  }

  transform(timecards: Timecard[], options: TimecardFilterSortOptions): Timecard[] {
    if (timecards) {
      switch (options.view) {

        case 'unsigned':
          return timecards
            .filter(t => t.statusId === TimecardStatus.Submitted)
            .filter(this.buildTimecardSearchPredicate(options.query))
            .sort(buildUnsignedTimecardComparator(options.sort));

        case 'signed':
          return timecards
            .filter(t => t.statusId === TimecardStatus.Signed || t.statusId === TimecardStatus.Approved)
            .filter(buildSignedTimecardPredicate(options.filter))
            .filter(this.buildTimecardSearchPredicate(options.query))
            .sort(buildSignedTimecardComparator(options.sort));

        default: // 'disputed'
          return timecards
            .filter(t => t.statusId === TimecardStatus.Disputed)
            .filter(this.buildTimecardSearchPredicate(options.query));
      }
    }

    return [];
  }

  buildTimecardSearchPredicate(query: string): (t: Timecard) => boolean {
    return t => {
      const locale = this.AppState.locale$.getValue();
      const fields = [
        NameFormatPipe.apply(t.reportTo, locale),
        NameFormatPipe.apply(t.talent, locale)
      ];

      const terms = query ? query.split(' ') : [];

      for (let i in fields) {
        const field = (fields[i] || '').toLowerCase();

        if (terms.every((term) => field.indexOf(term.toLowerCase()) !== -1)) {
          return true;
        }
      }

      return false;
    };
  }

}

function buildSignedTimecardPredicate(filter: string): (t: Timecard) => boolean {
  if (filter === 'signed') {
    return t => t.statusId === TimecardStatus.Signed;
  } else if (filter === 'approved') {
    return t => t.statusId === TimecardStatus.Approved;
  }

  return t => true;
}

function buildUnsignedTimecardComparator(sort: string): (t1: Timecard, t2: Timecard) => number {
  if (sort === 'date-submitted-desc') {
    return (t1, t2) => (t1.submitted > t2.submitted) ? -1 : 1;
  } else {
    return (t1, t2) => (t1.submitted > t2.submitted) ? 1 : -1;
  }
}

function buildSignedTimecardComparator(sort: string): (t1: Timecard, t2: Timecard) => number {
  if (sort === 'week-end-desc') {
    return (t1, t2) => (t1.weekEndingSunday > t2.weekEndingSunday) ? -1 : 1;
  } else {
    return (t1, t2) => (t1.weekEndingSunday > t2.weekEndingSunday) ? 1 : -1;
  }
}

